import { cn } from '~/utils/cn.ts';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			className={cn(
				// Lyra style: sharp corners
				'animate-pulse rounded-none bg-muted',
				className,
			)}
			data-slot="skeleton"
			{...props}
		/>
	);
}

export { Skeleton };
